import { type TFunction } from "i18next";

export const getCategoryTitle = (
  title: string | null | undefined,
  t: TFunction,
) => title ?? t(($) => $.commons.document.noCategoryLabel);
